import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LightboxService {
  private readonly imagesSource = new BehaviorSubject<string[]>([]);
  private readonly currentIndexSource = new BehaviorSubject<number | null>(null);
  private readonly showLightbox = new BehaviorSubject<boolean>(false);

  images$ = this.imagesSource.asObservable();
  currentIndex$ = this.currentIndexSource.asObservable();
  showLightbox$ = this.showLightbox.asObservable();

  open(images: string[], startIndex = 0) {
    this.imagesSource.next([...images]); // Ensure a new array is emitted
    this.currentIndexSource.next(startIndex);
    this.showLightbox.next(true);
  }

  close() {
    this.currentIndexSource.next(null);
    this.showLightbox.next(false);
  }

  next() {
    const images = this.imagesSource.getValue();
    const index = this.currentIndexSource.getValue();
    if (index !== null && index < images.length - 1) {
      this.currentIndexSource.next(index + 1);
    }
  }

  prev() {
    const index = this.currentIndexSource.getValue();
    if (index !== null && index > 0) {
      this.currentIndexSource.next(index - 1);
    }
  }
}
